import type { CamoId, CamoInfo } from "../../../api/types";
import { LockBadge } from "../../components/Badge";
import { OptionCard } from "../../components/OptionCard";
import { NO_CAMO } from "./draft";

export interface CamoPickerProps {
  /** Accessible name of the radio group. */
  label: string;
  camos: readonly CamoInfo[];
  selected: CamoId;
  /** Camo ids unlocked for this weapon (`none` is always available). */
  unlocked: readonly CamoId[];
  weaponLevel: number;
  onSelect: (id: CamoId) => void;
}

/** Radio row of camo swatches (diagonal two-color). */
export function CamoPicker({ label, camos, selected, unlocked, weaponLevel, onSelect }: CamoPickerProps) {
  return (
    <div class="loadouts__camos" role="radiogroup" aria-label={label}>
      {camos.map((camo) => {
        const locked = camo.id !== NO_CAMO && !unlocked.includes(camo.id);
        return (
          <OptionCard
            key={camo.id}
            role="radio"
            class="loadouts__camo"
            selected={camo.id === selected}
            locked={locked}
            title={locked ? `Requires weapon level ${camo.weaponLevel} (yours: ${weaponLevel})` : camo.name}
            ariaLabel={locked ? `${camo.name}, locked until weapon level ${camo.weaponLevel}` : camo.name}
            onClick={() => onSelect(camo.id)}
          >
            <span
              class="loadouts__swatch"
              style={{ "--camo-a": camo.colors[0], "--camo-b": camo.colors[1] }}
              aria-hidden="true"
            />
            <span class="loadouts__camo-name">{camo.name}</span>
            {locked && <LockBadge weapon level={camo.weaponLevel} class="loadouts__chip-lock" />}
          </OptionCard>
        );
      })}
    </div>
  );
}
